import { GetRequestPublic } from "./RequestTemplates";

export type LocationsResponse = {
  locations: Array<{
    id: number;
    mainName: string;
    name: string;
    partName: string;
  }>;
  result: string;
};

export type StreetsResponse = { Name: string }[];

export const fetchLocations = async (postalcode: string, category?: string): Promise<LocationsResponse> => {
  return GetRequestPublic(`${process.env.API_SERVER_URL}/locations/${category || "electricity"}?postCode=${postalcode}`).then(
    (res) => res.data
  );
};

export const fetchStreets = async (postalcode: string, city: string): Promise<StreetsResponse> => {
  return GetRequestPublic(`${process.env.API_SERVER_URL}/streets/${postalcode}?city=${city}`).then((res) => res.data);
};
